const breadcrumbNameMap = {
    '/genomics': 'Genomics',
    '/variations': 'Variations',
    '/genetics': 'Genetics',
    '/populations': 'Populations',
    '/epigenetics': 'Epigenetics',
    '/species/1': 'Gossypium hirsutum',
    '/species/2': 'Gossypium barbadense',
    '/species/3': 'Gossypium arboreum',
    '/search/site': 'Site Search',
    '/search/feature': 'Search Feature',
    '/search/gwas': 'Search GWAS',
    '/search/egwas': 'Search eGWAS',
    '/search/snp_indel': 'Search SNP & Indel',
    '/search/marker': 'Search Marker',
    '/search/trait': 'Search Trait',
    '/search/qtls': 'Search QTLs',
    '/search/haplotype': 'Search Haplotype',
    '/search/crispr': 'Search Crispr',
    '/tool/jbrowse_nav': 'Jbrowse',
    '/tool/pop_expression': 'Population Expression',
    '/tool/eqtlviz': 'eQTL Visualizer',
    '/tool/gwasviz': 'GWAS Visualizer',
    '/tool/gwas_single_trait': 'GWAS Single Trait',
    '/tool/gwas_multi_trait': 'GWAS Multi Trait',
    '/tool/gwas_single_variant': 'GWAS Single Variant',
    '/tool/snp_primer': 'SNP Primer Pipline',
    '/tool/gene_network': 'Gene Network',
    '/tool/id_converter': 'Gene ID Converter',
    '/about': 'About us',
    '/user/register': 'User account',
    '/user/login': 'User login',
    '/user/account': 'User Account',
    '/user/account/edit': 'User Account Edit',
    '/user/register': 'User Register',
    '/user/forgetpwd': 'Forget Password',
    '/notAllowed': 'Not Allowed',
}

export default breadcrumbNameMap
